import React from 'react'
import SearchInput from '../ui/SearhInput'
import { FaRegCalendarAlt } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { setDates } from '../../features/home/bookingSlice'

const DateSetter = ({ hourTime }: { hourTime?: boolean }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { checkIn, checkOut, duration } = useSelector(
    (state: RootState) => state.bookingSlice
  )

  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const handleCheckInChange = (value: Date) => {
    const newCheckIn = value < today ? today : value

    dispatch(
      setDates({
        checkIn: newCheckIn,
        checkOut,
      })
    )
  }

  const handleDurationChange = (value: 1 | 2) => {
    dispatch(
      setDates({
        checkIn,
        checkOut,
        duration: value
      })
    )
  }

  const durationOptions = [
    {
      value: 1,
      label_ar: 'الفترة الصباحية',
      label_en: 'Morning period'
    },
    {
      value: 2,
      label_ar: 'الفترة المسائية',
      label_en: 'Evening period'
    }
  ]

  return (
    <div className="flex flex-col gap-4">
      {hourTime ? (
        <div className="grid xs:grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Check In (Date + Time) */}
          <SearchInput
            value={checkIn}
            type="date"
            onChange={handleCheckInChange}
            placeholder={t('checkin-placeholder')}
            label={t('checkin-label')}
            icon={<FaRegCalendarAlt />}
          />

          {/* Duration */}
          <SearchInput
            value={duration ?? ''}
            type="select"
            onChange={handleDurationChange}
            label={t('duration-label')}
            placeholder={t('duration-placeholder')}
            options={durationOptions}
          />
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-4">
          <SearchInput
            value={checkIn}
            type="date"
            onChange={handleCheckInChange}
            placeholder={t('checkin-placeholder')}
            label={t('checkin-label')}
            icon={<FaRegCalendarAlt />}
          />

          <SearchInput
            value={checkOut}
            type="date"
            onChange={(value) =>
              dispatch(setDates({ checkIn, checkOut: value }))
            }
            placeholder={t('checkout-placeholder')}
            label={t('checkout-label')}
            icon={<FaRegCalendarAlt />}
          />
        </div>
      )}
    </div>
  )
}

export default DateSetter
